import React, { useMemo, useState } from 'react';

import PropTypes from 'prop-types';

import DialogContext from './DialogContext';

const DialogProvider = ({ children }) => {
  const [activeStatus, setActiveStatus] = useState(null);
  const [activeTask, setActiveTask] = useState(null);
  const [showDeleteStatusDialog, setShowDeleteStatusDialog] = useState(false);
  const [showDeleteTaskDialog, setShowDeleteTaskDialog] = useState(false);
  const [showStatusFormDialog, setShowStatusFormDialog] = useState(false);
  const [showTaskFormDialog, setShowTaskFormDialog] = useState(false);

  const handleCloseDeleteStatusDialog = () => {
    setShowDeleteStatusDialog(false);
    setActiveStatus(null);
  };

  const handleCloseDeleteTaskDialog = () => {
    setShowDeleteTaskDialog(false);
    setActiveTask(null);
  };

  const handleCloseStatusFormDialog = () => {
    setShowStatusFormDialog(false);
    setActiveStatus(null);
  };

  const handleCloseTaskFormDialog = () => {
    setShowTaskFormDialog(false);
    setActiveTask(null);
  };

  const handleDeleteStatusClick = (status) => {
    setActiveStatus(status);
    setShowDeleteStatusDialog(true);
  };

  const handleDeleteTaskClick = (task) => {
    setActiveTask(task);
    setShowDeleteTaskDialog(true);
  };

  const handleEditStatusClick = (status) => {
    setActiveStatus(status);
    setShowStatusFormDialog(true);
  };

  const handleEditTaskClick = (task) => {
    setActiveTask(task);
    setShowTaskFormDialog(true);
  };

  const handleNewStatusClick = () => {
    setShowStatusFormDialog(true);
  };

  const handleNewTaskClick = () => {
    setShowTaskFormDialog(true);
  };

  const contextValue = useMemo(
    () => ({
      activeStatus,
      activeTask,
      handleCloseDeleteStatusDialog,
      handleCloseDeleteTaskDialog,
      handleCloseStatusFormDialog,
      handleCloseTaskFormDialog,
      handleDeleteStatusClick,
      handleDeleteTaskClick,
      handleEditStatusClick,
      handleEditTaskClick,
      handleNewStatusClick,
      handleNewTaskClick,
      showDeleteStatusDialog,
      showDeleteTaskDialog,
      showStatusFormDialog,
      showTaskFormDialog,
    }),
    [
      activeStatus,
      activeTask,
      showDeleteStatusDialog,
      showDeleteTaskDialog,
      showStatusFormDialog,
      showTaskFormDialog,
    ]
  );

  return <DialogContext.Provider value={contextValue}>{children}</DialogContext.Provider>;
};

DialogProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default DialogProvider;
